import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import StockScanPopup from "./StockScanPopup";
import AccessDenied from "../../AccessDenied";
import { useAuth } from "../../../contexts/AuthContext";
import { parseScanParams } from "./stockQrUtils";
import { clearPendingScan } from "./PendingScan";

// Route target for the URL encoded in the QR code, e.g. <Route path="/stock-scan" element={<StockScanPage />} />
// Only ROLE_INVENTORY-MANAGER may open it; everyone else sees Access Denied.
const StockScanPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const params = useMemo(() => parseScanParams(window.location.search), []);

  useEffect(() => {
    clearPendingScan();
  }, []);

  if (!user?.authorities?.includes("ROLE_INVENTORY-MANAGER"))
    return <AccessDenied />;

  return (
    <StockScanPopup
      params={params}
      onClose={() => navigate("/crm", { replace: true })}
    />
  );
};

export default StockScanPage;
